<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const topLevelCacheIncludes = computed(() => {
  const usesHomeLayout = route.matched.some(
    (record) => record.components?.default?.name === "HomeLayout",
  );
  return usesHomeLayout || route.meta.keepHomeLayout
    ? ["HomeLayout"]
    : [];
});
</script>

<template>
  <router-view v-slot="{ Component }">
    <keep-alive :include="topLevelCacheIncludes">
      <component :is="Component" />
    </keep-alive>
  </router-view>
  <!-- 智能客服：登录并取得用户资料后可用，注销时销毁会话窗口 -->
  <customer-service-widget />
</template>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--app-text-color);
}
html,
body {
  border: 0;
  padding: 0;
  margin: 0;
}
.is-fullscreen {
  height: 100% !important;
  overflow-y: auto !important;
   :deep(){
    .el-dialog__body {
      height: 88% !important;
      overflow-y: auto !important;
      max-height: none !important;
    }
    .el-button--small{
      padding: 9px 15px !important;
      height:auto;
    }
   }
}
</style>
